import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'

import * as SC from './styled'

export type PageTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  html?: string
}

const PageTemplate: FC<PageTemplateProps> = (props) => {
  const { layout, html } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>{html && <SC.Body dangerouslySetInnerHTML={{ __html: html }} />}</SC.Content>
    </DefaultLayout>
  )
}

export default PageTemplate
